// A tab opened before a deploy still points at the old build's hashed chunks, and a
// deploy removes them — so the next lazy screen, dialog or the Bangla dictionary
// fails to load ("Failed to fetch dynamically imported module"). Vite reports every
// such failure as `vite:preloadError`; reload once so the tab picks up the new build.
// A short guard stops a reload loop when the chunk is missing for another reason.
const GUARD_KEY = 'bd.stale-chunk-reload';
const GUARD_MS = 10_000;

export function reloadOnStaleChunk(win: Window = window): () => void {
  const onError = (event: Event) => {
    let last = 0;
    try {
      last = Number(win.sessionStorage.getItem(GUARD_KEY)) || 0;
    } catch {
      // Storage blocked: fall through and reload once anyway.
    }
    if (Date.now() - last < GUARD_MS) return;
    try {
      win.sessionStorage.setItem(GUARD_KEY, String(Date.now()));
    } catch {
      // Storage blocked: the reload still happens.
    }
    event.preventDefault();
    win.location.reload();
  };
  win.addEventListener('vite:preloadError', onError);
  return () => win.removeEventListener('vite:preloadError', onError);
}
